export default "__VITE_ASSET__q4Zu8s73__"